<template>
        
    <!-- Infos -->
    <aside class="Dropdown-infos">
        <div 
            class="Dropdown-infos__info-head"
            :class="{hasDropdownContent: hasDropdownContent}"
            @click="toggleInfosDetails"
        >
            <svg v-svg symbol="Info" size="0 0 15 15" role="presentation" class="icon--inline"></svg>
            <p>{{ headText }}</p>
            <template v-if="hasDropdownContent">
                <svg
                    v-svg 
                    symbol="Arrow_Down" 
                    size="0 0 10 10" 
                    role="presentation" 
                    class="icon--inline dropdown-arrow"
                    :class="{rotated: showDropdownContent}"
                ></svg>
            </template>
            
        </div>

        <p 
            v-if="showDropdownContent && hasDropdownContent"
            class="Dropdown-infos__info-content"
            :inner-html.prop="contentText"
        >
        </p>

    </aside>

</template>

<script>
import './DropdownInfos.scss';


export default {
    name: "DropdownInfos",


    props: {
        headText : {
            type: String,
            default: ''
        },
        contentText: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            showDropdownContent : false,
            hasDropdownContent: false,
        };
    },

    methods: {
        toggleInfosDetails() {
            this.showDropdownContent = !this.showDropdownContent
        },
    },

    created() {
        this.hasDropdownContent = this.contentText != '';
    },
    
}
</script>